// extracted by mini-css-extract-plugin
export default {"title":"AnnouncmentAndSalesCategory_title__wj2S0","row":"AnnouncmentAndSalesCategory_row__xG3iT","col":"AnnouncmentAndSalesCategory_col__1ETiq"};